export default class ContactAvatar {

    constructor($scope, LocaleService) {

        function getKanjiInitials(name) {
            if (name.length < 3) return name;
        }

        function getCompanyInitials(name) {
            // Remove multiple extra spaces
            // and split the company first and second name
            const parts = name.replace(/ +(?= )/g, '').split(' ');
            if (parts.length > 1) {
                const [firstName, secondName] = parts;
                firstName[0] + secondName[0];
            }
            return name[0];
        }


        function getInitials(contact) {
            const countryCode = LocaleService.getCountry();
            const {
                subtype,
                displayName,
                contactNameKanji,
                lastNameKanji,
                firstName,
                lastName
            } = contact;
            if (subtype === 'Company') {
                if (contactNameKanji) return getKanjiInitials(contactNameKanji);
                return getCompanyInitials(displayName);
            }
            if (lastNameKanji) return getKanjiInitials(lastNameKanji);
            if (countryCode === 'FR' || countryCode === 'JP') {
                return lastName[0] + firstName[0];
            }
            return firstName[0] + lastName[0];
        }

        this.$onInit = () => {
            this.initials = getInitials(this.contact);
        };
    }
}